import React, { Component } from "react";
import { Dashboard } from "@uppy/react";
import { observer } from "mobx-react";
import { Button, Grid, Message } from "semantic-ui-react";
import PropTypes from "prop-types";
import Immersive3dTourAppPageStore from "~/stores/Immersive3dTourAppPageStore";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

@observer
class UploadSection extends Component {
  constructor(props) {
    super(props);

    const { immersive3dTourAppPageStore } = this.props;
    const { immersive3dTourTabStore } = immersive3dTourAppPageStore;

    immersive3dTourTabStore.createUploader();
  }

  render() {
    const { immersive3dTourAppPageStore } = this.props;

    const { immersive3dTourTabStore } = immersive3dTourAppPageStore;
    // const { immersive3dTourStore } = immersive3dTourTabStore;

    const {
      isUploading,
      hasUppyUploadError,
      hasNewPanoramas,
      uploader,
      message,
      newPanoramasCount,
    } = immersive3dTourTabStore;

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <h2 className="ui header">Upload your panoramas {`(${newPanoramasCount} uploaded)`}</h2>
          </Grid.Column>
          <Grid.Column width={8} textAlign="right">
            <Button.Group>
              {!isUploading && !hasUppyUploadError && hasNewPanoramas && (
                <Button
                  secondary
                  onClick={() => {
                    immersive3dTourTabStore.forceShowUpload = false;
                  }}
                  disabled={isUploading}
                >
                  Edit panoramas
                </Button>
              )}
              {immersive3dTourAppPageStore.hasCompletedProcessingWithSuccess && (
                <Button
                  secondary
                  onClick={() => {
                    immersive3dTourTabStore.forceShowUpload = false;
                    immersive3dTourTabStore.resetFloors();
                  }}
                  disabled={isUploading}
                >
                  Edit Immersive 3D Tour
                </Button>
              )}
            </Button.Group>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            <Message
              positive
              content="We accept any 360 images that use an equirectangular projection. For best results, use a Ricoh Z1 or Ricoh SC2 camera."
            />
            <Message warning>
              <Message.Header>Have you processed your exposures?</Message.Header>
              <p>Please make sure you have processed the HDR images before uploading in Immersive 3D Tour.</p>
            </Message>
          </Grid.Column>
        </Grid.Row>
        {message && (
          <Grid.Row>
            <Grid.Column width={16}>
              <Message
                positive={message.type === "positive"}
                negative={message.type === "negative"}
                header={message.header}
                content={message.content}
              />
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Column width={16}>
            <Dashboard
              uppy={uploader}
              showLinkToFileUploadResult={false}
              width="100%"
              height="300px"
              proudlyDisplayPoweredByUppy={false}
              showSelectedFiles={false}
              showProgressDetails
              waitForThumbnailsBeforeUpload
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

UploadSection.propTypes = {
  immersive3dTourAppPageStore: PropTypes.instanceOf(Immersive3dTourAppPageStore),
};

export default UploadSection;
